import { render, staticRenderFns } from "./Passengerupdate.vue?vue&type=template&id=ced2d46a&scoped=true"
import script from "./Passengerupdate.vue?vue&type=script&lang=js"
export * from "./Passengerupdate.vue?vue&type=script&lang=js"
import style0 from "./Passengerupdate.vue?vue&type=style&index=0&id=ced2d46a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ced2d46a",
  null
  
)

export default component.exports